<template>
  <vs-row vs-type="flex" vs-w="12" id="cartEntryPage" class="pt-6" :class="{'kiosk-cart-entry': isKiosk}" style="height:100%!important;">
    <recipe-reviewer ref="recipeReviewer"/>
    <product-description ref="productDescription"/>
    <vs-popup :active.sync="isVariantSelectionOpen" title="Alternatif Ürün Seçimi" id="variant-first-selection">
      <vs-row vs-type="flex" vs-w="12" class="bg-primary2">
        <vs-col vs-type="flex" vs-w="12" vs-justify="space-between" class="mx-5 py-4">
          <vs-button radius icon-pack="feather" icon="icon-x" color="tranparent" class="bg-secondary text-primary"
                     @click="closeVariantSelection"></vs-button>
        </vs-col>
      </vs-row>
      <vs-row v-if="selectedRawMaterial!=null" vs-type="flex" vs-w="12" vs-justify="center" class="p-5">
        <vs-col vs-type="flex" class="w-auto mx-5 my-3" v-for="(variant) in selectedRawMaterial.variants"
                :key="variant.id">
          <vs-button class="half-friendly-border bold sale-box-shadow text-dark"
                     :class="{'bg-primary text-white' : variant.selected}" @click="variantSelection(variant)"
                     size="large"
                     color="transparent">{{ variant.name }}
          </vs-button>
        </vs-col>
      </vs-row>

    </vs-popup>

    <vs-row v-show="!isExtraSelectionOpen" vs-w="12" vs-justify="center" vs-align="center">
      <vs-col :vs-w="isKiosk ? 0 : 3" vs-xs="12" v-if="!isKiosk || (selectedRecipe.productExtras!=null && selectedRecipe.productExtras.length>0)">
        <vs-row vs-type="flex" vs-w="12" v-if="!isKiosk">
          <vs-button v-if="selectedRecipe.productExtras!=null && selectedRecipe.productExtras.length>0" size="small"
                     class="w-full mt-6 bold extra-button text-white half-friendly-border bg-primary2 sale-box-shadow"
                     color="transparent" @click="openExtraSelection">
            Ekstralar
          </vs-button>
          <div class="w-full extra-list text-primary bold">
            <vs-row v-for="extra in realSelectedExtras" :key="extra.id" vs-w="12" class="py-2 px-3"
                    style="border-bottom: 1px dashed #ddd" vs-justify="center">
              <vs-col vs-type="flex" class="w-auto">
                + {{ extra.quantity + " " }} {{ " " + extra.name + " " }}
                {{ $toCurrency(extra.quantity * extra.price) }}
              </vs-col>
            </vs-row>
          </div>
        </vs-row>
      </vs-col>
      <vs-col vs-type="flex" :vs-w="isKiosk ? 12 : 4" vs-xs="12">
        <vs-row vs-type="flex" vs-w="12" :vs-justify="isKiosk ? 'center' : 'center'">
          <vs-row vs-type="flex" vs-w="12" vs-justify="center" :class="{'kiosk-image-row': isKiosk}">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" :vs-w="isKiosk ? 10 : 12">
              <vx-tooltip :text="description" position="right">
                <img
                :src="selectedProduct && selectedProduct.imageUrl ? $baseUrl + '/' + selectedProduct.imageUrl : toUpdateEntry && toUpdateEntry.rawProduct.imageUrl ? $baseUrl + '/' + toUpdateEntry.rawProduct.imageUrl : productPlaceHolder"
                class="responsive cartEntryImg" @click="openRecipeReviewer">
              </vx-tooltip>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2" v-if="isKiosk">
              <vs-button @click="openDescription"
                         class="sale-text-shadow bg-primary2 sale-box-shadow text-light half-friendly-border kiosk-info-side-btn"
                         color="transparent" icon-pack="feather" icon="icon-info">
              </vs-button>
            </vs-col>
          </vs-row>
          <vs-row v-if="!isKiosk" vs-w="12" vs-justify="center" :class="isKiosk ? 'mt-2' : 'mt-5'">
            <vs-button @click="quantity++"
                       class="sale-text-shadow bg-primary2 sale-box-shadow text-light quantity-label half-friendly-border"
                       color="transparent" style="height:3.5rem!important;">Adet
            </vs-button>
          </vs-row>
          <vs-row v-if="!isKiosk" vs-w="12" vs-justify="center" vs-align="center" :class="{'mt-10': isKiosk}">
            <vs-button class="quantity-button bg-white text-primary" size="medium" radius color="transparent"
                       type="gradient" icon-pack="feather" icon="icon-minus" @click="quantity > 1 ? quantity-- : null">
            </vs-button>
            <p class="selected-quantity">{{ quantity }}</p>
            <vs-button class="quantity-button bg-white text-primary" size="medium" radius color="transparent"
                       type="gradient" icon-pack="feather" icon="icon-plus" @click="quantity++"></vs-button>
          </vs-row>
          <vs-row vs-w="12" vs-justify="center" class="mt-2" v-if="selectedRecipe && productName && productName.length > 0">
            <div class="selected-product-info-highlight">
              <div class="product-name">{{ productName.filter(n => n).join(' ') }}</div>
              <div class="product-price">{{ $toCurrency(selectedRecipe.price) }}</div>
              <vx-tooltip :text="description" position="bottom" v-if="!isKiosk">
                <vs-button @click="openDescription"
                           class="sale-text-shadow bg-primary2 sale-box-shadow text-light half-friendly-border info-button"
                           color="transparent">Bilgi
                </vs-button>
              </vx-tooltip>
            </div>
          </vs-row>
        </vs-row>
      </vs-col>
      <vs-col :vs-w="isKiosk ? 0 : 3" vs-xs="12" class="mt-6 pr-6 hidden-xs" v-if="!isKiosk">
        <!-- Bilgi butonu buradan kaldırıldı -->
      </vs-col>
    </vs-row>
    <vs-row v-if="isRawMaterialsReload && !isExtraSelectionOpen" vs-type="flex" vs-w="12" vs-justify="center" id="cartEntryRecipeSteps"
            class="px-3">
      <div class="my-2 px-1 pointer" style="width: 30%;height: 90px;"
           v-for="(step) in selectedRecipe.recipeSteps.filter(x=> (x.rawMaterial.variants != null && x.rawMaterial.variants.length > 0) || x.isRemovable === true)"
           :key="step.id"
      >
        <div class="w-full h-full">
          <div class="recipeStepHeader justify-center w-full variant-label sale-text-shadow px-2 py-1"
               :class="{'bg-primary2' : step.rawMaterial.variants != null && step.rawMaterial.variants.length > 0, 'bg-secondary' : step.rawMaterial.variants == null || step.rawMaterial.variants.length === 0 }"
               style="position: relative; min-height: 29px;">
            <p
              v-if="step.rawMaterial.variants != null && step.rawMaterial.variants.length > 0"
              class="text-white text-primary">
              {{ step.rawMaterial.name }}</p>
            <vs-button @click="removeRecipeStep(step)"
                       v-if="step.isRemovable === true"
                       icon-pack="feather" style="position: absolute; right: 0; top: -3px;"
                       :class="{'text-dark' : step.rawMaterial.variants == null || step.rawMaterial.variants.length === 0, 'text-white' : step.rawMaterial.variants != null && step.rawMaterial.variants.length !== 0}"
                       icon="icon-x" color="transparent" type="gradient"/>
          </div>
          <div class="recipeStepDetail justify-center bg-secondary d-flex mx-auto overflow-auto"
               :class="{'sale-box-shadow' : step.isRemoved === false}"
               style="height: inherit; flex-direction: column; width: 90%" @click="updateVariant(step.rawMaterial)">
            <p class="text-smaller text-center bold px-2"
            :class="{'line-through' : step.isRemoved === true, 'text-dark' : step.isRemoved === false}">
              {{
                step.rawMaterial.variants != null && step.rawMaterial.variants.length > 0 ? getSelectedVariant(step.rawMaterial.variants).name : step.rawMaterial.name
              }}</p>
          </div>
        </div>
      </div>
    </vs-row>

    <vs-row v-if="isExtraSelectionOpen" vs-type="flex" vs-w="12">
      <extra-selection :extras="selectedExtras.length>0?selectedExtras:selectedRecipe.productExtras"
                       @saveExtras="saveExtraSelection" @cancelExtras="cancelExtraSelection"></extra-selection>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" :class="isKiosk ? 'mt-2' : 'mt-5'" vs-justify="center" vs-align="center" v-if="!isExtraSelectionOpen">
      <vs-col vs-type="flex" :vs-w="isKiosk ? 4 : 5" :vs-xs="isKiosk ? 4 : 12" vs-justify="center" :class="{'mb-4': !isKiosk}">
        <vs-button class="action-button sale-box-shadow w-full" :class="isKiosk ? 'mx-2' : 'mx-5'" color="danger" type="gradient"
                   @click="GoToProductSelectPage" icon-pack="feather"
                   icon="icon-arrow-left">
          VAZGEÇ
        </vs-button>
      </vs-col>
      
      <vs-col v-if="isKiosk" vs-type="flex" vs-w="4" vs-xs="4" vs-justify="center" vs-align="center" class="px-2">
          <div class="kiosk-footer-quantity-container">
            <vs-button class="quantity-button bg-white text-primary" size="large" radius color="transparent"
                       type="gradient" icon-pack="feather" icon="icon-minus" @click="quantity > 1 ? quantity-- : null">
            </vs-button>
            <p class="selected-quantity">{{ quantity }}</p>
            <vs-button class="quantity-button bg-white text-primary" size="large" radius color="transparent"
                       type="gradient" icon-pack="feather" icon="icon-plus" @click="quantity++"></vs-button>
          </div>
      </vs-col>

      <vs-col vs-type="flex" :vs-w="isKiosk ? 4 : 5" :vs-xs="isKiosk ? 4 : 12" vs-justify="center">
        <vs-button class="action-button sale-box-shadow w-full bg-success2 text-light" :class="isKiosk ? 'mx-2' : 'mx-5'"
                   @click="AddToCart" color="transparent" icon-pack="feather" icon="icon-arrow-right" icon-after>
          ONAYLA
        </vs-button>
      </vs-col>
    </vs-row>
  </vs-row>
</template>
<script>
import RecipeReviewer from "@/views/pages/Recipe/RecipeReviewer"
import ExtraSelection from "./ExtrasSelection";
import ProductDescription from "./ProductDescription";
import {
  uuid
} from "vue-uuid";
import { addDiscountLog } from "@/api/SelfService";
/* eslint-disable */
export default {
  components: {
    ExtraSelection,
    RecipeReviewer,
    ProductDescription
  },
  props: {
    isKiosk: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      productPlaceHolder: require("@/assets/images/products/product-kahve.png"),
      isExtraSelectionOpen: false,
      quantity: 1,
      rawMaterials: [],
      selectedRecipe: {},
      productName: [""],
      isVariantSelectionOpen: false,
      selectedRawMaterial: null,
      isRawMaterialsReload: true,
      selectedExtras: []
    };
  },
  computed: {
    realSelectedExtras() {
      let returnObj = [];
      this.selectedExtras.filter(x => {
        if (x.quantity > 0) {
          returnObj.push(x);
        } else if (x.variants != null && x.variants.length > 0) {
          if (x.variants.some(z => z.quantity > 0)) {
            x.variants.filter(y => y.quantity > 0).forEach(variantExtra => {
              returnObj.push(variantExtra);
            })
          }
        }
        ;
      });
      return returnObj.length > 0 ? returnObj : null;
    },
    currentCart: function () {
      return this.$store.getters["selfservice/getCurrentCart"];
    },
    toUpdateEntry() {
      return this.$store.getters["selfservice/getToUpdateEntry"];
    },
    selectedProduct: function () {
      return this.$store.getters["selfservice/getSelectedProduct"];
    },
    activeCart: function () {
      return this.$store.getters["selfservice/getCurrentCart"];
    },
    description: function(){
      if (this.selectedProduct == null) {
        if (!this.toUpdateEntry.rawProduct || !this.toUpdateEntry.rawProduct.children) return '';
    const selectedChild = this.toUpdateEntry.rawProduct.children.find(x => x.isSelected);
    return selectedChild ? selectedChild.description || '' : '';
      }else{
        if (!this.selectedProduct || !this.selectedProduct.children) return '';
    const selectedChild = this.selectedProduct.children.find(x => x.isSelected);
    return selectedChild ? selectedChild.description || '' : '';
      }
    }
  },
  created: function () {
    if (!this.toUpdateEntry) {
      this.selectedRecipe = this.findSelectedProductInDeep(this.selectedProduct);
      this.selectedRecipe.image = this.selectedProduct.imageUrl
    } else {
      this.selectedRecipe = this.findSelectedProductInDeep(this.toUpdateEntry.rawProduct);
      this.selectedRecipe.recipeSteps.forEach(step => {
        step.isRemoved = this.toUpdateEntry.recipe.steps.find(x => x.stepId === step.id).isRemoved
        step.isRemovable = this.toUpdateEntry.recipe.steps.find(x => x.stepId === step.id).isRemovable
      })
      this.selectedRecipe.image = this.toUpdateEntry.rawProduct.imageUrl
      this.quantity = this.toUpdateEntry.quantity;
      this.productId = this.toUpdateEntry.productId;
      this.childProductId = this.toUpdateEntry.childProductId;
      this.selectedExtras = this.toUpdateEntry.extras;
      this.setSelectedVariant();
    }
  },
  watch: {
    isVariantSelectionOpen: function (val) {
      if (!val) {
        this.selectedRawMaterial = null;
      }
    },
    toUpdateEntry: {
      handler(val) {
        this.productName = [""];
        this.selectedRecipe = this.findSelectedProductInDeep(this.toUpdateEntry.rawProduct);
        this.selectedRecipe.recipeSteps.forEach(step => {
          step.isRemoved = this.toUpdateEntry.recipe.steps.find(x => x.stepId === step.id).isRemoved
        })
        this.quantity = this.toUpdateEntry.quantity;
        this.productId = this.toUpdateEntry.productId;
        this.childProductId = this.toUpdateEntry.childProductId;
        this.selectedExtras = this.toUpdateEntry.extras;
        this.selectedRecipe.price = val.price;
        this.setSelectedVariant();
      },
      deep: true

    },
  },
  methods: {
    removeRecipeStep(step) {
      step.isRemoved = !step.isRemoved
    },
    toggleRecipeStep(recipeStep) {
      recipeStep.isRemoved = !recipeStep.isRemoved
    },
    openRecipeReviewer() {
      this.$refs.recipeReviewer.recipe = this.selectedRecipe
      this.$refs.recipeReviewer.isActive = true
    },
    openDescription(){
      this.$refs.productDescription.isActive = true;
      this.$refs.productDescription.description = this.description;
      this.$refs.productDescription.image = this.selectedProduct && this.selectedProduct.imageUrl ? this.$baseUrl + '/' + this.selectedProduct.imageUrl : this.toUpdateEntry && this.toUpdateEntry.rawProduct.imageUrl ? this.$baseUrl + '/' + this.toUpdateEntry.rawProduct.imageUrl : this.productPlaceHolder
    },
    setSelectedVariant() {
      this.toUpdateEntry.recipe.steps.forEach(step => {
        let raw = this.selectedRecipe.recipeSteps.find(x => x.rawMaterial.id == step.originRawMaterialId);
        if (raw) {
          let selectedVariant = raw.rawMaterial.variants.find(y => y.id == step.id);
          selectedVariant.selected = true;
        }
      });
    },
    resetCartEntry() {
      this.selectedRecipe.recipeSteps.forEach(x => {
        x.rawMaterial.variants.forEach(v => {
          v.selected = false;
        });
      });
    },
    calculateUpdateCartEntry() {
      let tempEntry = {};
      tempEntry.categories = _.cloneDeep(this.toUpdateEntry.categories);
      tempEntry.id = this.toUpdateEntry.id;
      tempEntry.quantity = this.quantity;
      tempEntry.productId = this.toUpdateEntry.productId;
      tempEntry.productSize = this.toUpdateEntry.productSize;
      tempEntry.childProductId = this.toUpdateEntry.childProductId;
      tempEntry.extras = this.selectedExtras;
      tempEntry.productName = this.toUpdateEntry.productName;
      tempEntry.kdv = this.toUpdateEntry.kdv;
      tempEntry.recipe = {
        id: this.selectedRecipe.id,
        steps: []
      };
      this.selectedRecipe.recipeSteps.forEach(step => {
        let tempVariant = null;
        if (step.rawMaterial != null && step.rawMaterial.variants != null && step.rawMaterial.variants.length >
          0) {
          tempVariant = this.getSelectedVariant(step.rawMaterial.variants);
          tempVariant.stepId = step.id;
          tempVariant.isRemoved = step.isRemoved;
          tempVariant.isRemovable = step.isRemovable;
          
          // God Mode Robustness: Ensure name is available both flat and nested
          const vName = tempVariant.name || tempVariant.Name || '';
          tempVariant.name = vName;
          tempVariant.Name = vName;
          if (!tempVariant.rawMaterial) {
            tempVariant.rawMaterial = { id: tempVariant.id, name: vName, Name: vName };
          }

          tempEntry.recipe.steps.push(tempVariant);
        } else {
          tempVariant = _.cloneDeep(step.rawMaterial);
          tempVariant.stepId = step.id;
          tempVariant.isRemoved = step.isRemoved;
          tempVariant.isRemovable = step.isRemovable;
          
          // God Mode Robustness: Ensure name is available both flat and nested
          const mName = tempVariant.name || tempVariant.Name || '';
          tempVariant.name = mName;
          tempVariant.Name = mName;
          if (!tempVariant.rawMaterial) {
             tempVariant.rawMaterial = { id: tempVariant.id, name: mName, Name: mName };
          }

          tempEntry.recipe.steps.push(tempVariant);
        }
      });
      tempEntry.price = this.selectedRecipe.price;
      if (tempEntry.extras && tempEntry.extras.length > 0) {
        tempEntry.extras.forEach(extra => {
          if (extra.variants != null && extra.variants.length > 0) {
            extra.variants.forEach(extraVariant => {
              if (extraVariant.quantity > 0) tempEntry.price = tempEntry.price + (extraVariant.price *
                extraVariant.quantity)
            });
          } else tempEntry.price = tempEntry.price + (extra.quantity * extra.price);
        });
      }
      tempEntry.price = tempEntry.price * tempEntry.quantity;
      return tempEntry;
    },
    calculateCartEntry: async function () {
      let tempEntry = {};
      tempEntry.categories = _.cloneDeep(this.selectedProduct.categories);
      tempEntry.id = uuid.v1();
      tempEntry.quantity = this.quantity;
      tempEntry.productSize = this.selectedProduct.sizeId;
      tempEntry.productId = this.selectedProduct.id;
      tempEntry.childProductId = this.childProduct.id;
      tempEntry.extras = this.selectedExtras;
      tempEntry.productName = this.productName.join("->").slice(2);
      tempEntry.kdv = this.childProduct.kdv;
      tempEntry.recipe = {
        id: this.selectedRecipe.id,
        steps: []
      };
      this.selectedRecipe.recipeSteps.forEach(step => {
        let tempVariant = null;
        if (step.rawMaterial != null && step.rawMaterial.variants != null && step.rawMaterial.variants.length >
          0) {
          tempVariant = step.rawMaterial.variants.find(x => x.selected === true);
          tempVariant.isRemoved = step.isRemoved;
          tempVariant.isRemovable = step.isRemovable;
          tempVariant.stepId = step.id;
          tempVariant.selected = true;
          
          // God Mode Robustness: Ensure name is available both flat and nested
          const vName = tempVariant.name || tempVariant.Name || '';
          tempVariant.name = vName;
          tempVariant.Name = vName;
          if (!tempVariant.rawMaterial) {
            tempVariant.rawMaterial = { id: tempVariant.id, name: vName, Name: vName };
          }

          tempEntry.recipe.steps.push(_.cloneDeep(tempVariant));
        } else {
          tempVariant = _.cloneDeep(step.rawMaterial);
          tempVariant.isRemoved = step.isRemoved;
          tempVariant.isRemovable = step.isRemovable;
          tempVariant.stepId = step.id;
          
          // God Mode Robustness: Ensure name is available both flat and nested
          const mName = tempVariant.name || tempVariant.Name || '';
          tempVariant.name = mName;
          tempVariant.Name = mName;
          if (!tempVariant.rawMaterial) {
            tempVariant.rawMaterial = { id: tempVariant.id, name: mName, Name: mName };
          }

          tempEntry.recipe.steps.push(tempVariant);
        }
      });

      tempEntry.price = this.selectedRecipe.price;
      if (tempEntry.extras && tempEntry.extras.length > 0) {
        tempEntry.extras.forEach(extra => {
          if (extra.variants != null && extra.variants.length > 0) {
            extra.variants.forEach(extraVariant => {
              if (extraVariant.quantity > 0) tempEntry.price = tempEntry.price + (extraVariant.price *
                extraVariant.quantity)
            });
          } else tempEntry.price = tempEntry.price + (extra.quantity * extra.price);
        });
      }

      tempEntry.price = tempEntry.price * tempEntry.quantity;
      return tempEntry;

    },
    AddToCart: async function () {
      if (this.toUpdateEntry) {
        let oldQuantity = this.toUpdateEntry.quantity;
        let newQuantity = this.quantity;
        let item = this.calculateUpdateCartEntry();
        item.price = Math.round(item.price * 100) / 100
        item.originPrice = item.price
        item.rawProduct = _.cloneDeep(this.toUpdateEntry.rawProduct);
        let oldEntryIndex = this.currentCart.cartEntries.findIndex(x => x.id == item.id);
        let updateObj = {
          index: oldEntryIndex,
          entry: item
        };
        this.resetCartEntry();
        this.$store.dispatch("selfservice/updateToCart", updateObj);
 
        // Logging for Update
        try {
          await addDiscountLog({
            tableId: 0,
            ids: [item.id],
            totalDiscount: 0,
            discountType: "Update",
            actionType: "Update",
            description: `eski adet:${oldQuantity} yeni adet:${newQuantity}`,
            items: [item]
          });
        } catch (logErr) {
          console.error("StaffActionLog Update error:", logErr);
        }
      } else {
        let item = await this.calculateCartEntry();
        item.price = Math.round(item.price * 100) / 100
        item.originPrice = item.price
        item.rawProduct = _.cloneDeep(this.selectedProduct);
        this.$store.dispatch("selfservice/addToCart", item);
        this.$store.dispatch("selfservice/setSelectedProduct", null);
        this.resetCartEntry();
 
        // Logging for Add
        try {
          await addDiscountLog({
            tableId: 0,
            ids: [item.id],
            totalDiscount: 0,
            discountType: "Add",
            actionType: "Add",
            description: "",
            items: [item]
          });
        } catch (logErr) {
          console.error("StaffActionLog Add error:", logErr);
        }
      }
    },
    GoToProductSelectPage: function () {
      if (this.toUpdateEntry) {
        this.resetCartEntry();
        this.$store.dispatch("selfservice/setToUpdateEntry", null)
      } else
        this.$store.dispatch("selfservice/setSelectedProduct", null);
    },
    getSelectedVariant: function (variants) {
      let selectedItem = variants.find(x => x.selected == true);
      if (selectedItem == null) {
        variants.forEach(item => {
          if (item.isDefault == true) {
            item.selected = true;
            selectedItem = item;
          } else {
            item.selected = false;
          }
        });
      }
      return _.cloneDeep(selectedItem);

    },
    findSelectedProductInDeep: function (rawProduct) {
      let product = _.cloneDeep(rawProduct)
      this.productName.push(product.name);
      if (product.children == null && product.isSelected) {
        product.recipe.price = product.price;
        this.childProduct = product;
        return product.recipe;
      } else if (product.children != null) {
        let selectedChildren = product.children.find(x => x.isSelected);
        return this.findSelectedProductInDeep(selectedChildren);
      }
    },
    updateVariant(rawMaterial) {
      if (rawMaterial.variants != null && rawMaterial.variants.length > 0) {
        this.selectedRawMaterial = rawMaterial;
        this.isVariantSelectionOpen = true;
      }
    },
    closeVariantSelection() {

      this.isVariantSelectionOpen = false;
      this.selectedRawMaterial = null;

    },
    variantSelection(variant) {
      this.isRawMaterialsReload = false;

      this.selectedRawMaterial.variants.forEach(item => {

        if (variant.id === item.id) {
          item.selected = true;
        } else {
          item.selected = false;
        }
      });
      this.selectedRecipe.recipeSteps.find(x => x.rawMaterial.id == this.selectedRawMaterial.id).rawMaterial.variants
        .find(y => y.id == variant.id).selected = true;

      this.isVariantSelectionOpen = false;
      this.selectedRawMaterial = null;

      this.$nextTick(() => {
        this.isRawMaterialsReload = true;
      });
    },
    openExtraSelection() {
      this.isExtraSelectionOpen = true;
    },
    saveExtraSelection(selectedExtras) {
      this.selectedExtras = selectedExtras;
      this.isExtraSelectionOpen = false;
    },
    cancelExtraSelection() {
      this.isExtraSelectionOpen = false;
    }
  }
};

</script>
<style>
.cartEntryImg{
  max-height: 300px !important;
}
.variant-title {
  font-weight: 600 !important;
  font-size: 1rem !important;
  color: #eeeeee !important;
}

.line-through {
  text-decoration: line-through;
}

.action-button {
  font-size: 1.2vw !important;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 20px;
  font-weight: 600 !important;
  border-radius: 1rem !important;
  text-shadow: 1px 1px 1px rgb(63, 63, 63) !important;
}

#variant-first-selection .vs-popup .vs-popup--content {
  margin: 0 !important;
  padding: 0 !important;
  width: 100% !important;
  border-top-left-radius: 2rem !important;
  border-top-right-radius: 2rem !important;
}

#variant-first-selection .vs-popup {
  border-top-left-radius: 2rem !important;
  border-top-right-radius: 2rem !important;
}

#variant-first-selection .vs-popup .vs-popup--content .vs-row .vs-col button i {
  font-weight: 600 !important;
}

#variant-first-selection .vs-popup .vs-popup--header {
  display: none !important;
}

.border {
  border: 2px solid black;
}

.category {
  height: fit-content !important;
  padding: 0 !important;
}

.quantity-label {
  opacity: 1 !important;
  padding-left: 2.75rem !important;
  padding-right: 2.75rem !important;
  font-size: 1.05rem !important;
  font-weight: 600 !important;
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
  letter-spacing: 1.2px
}

.selected-quantity {
  font-size: 1.25rem;
  margin-left: 1.25rem;
  margin-right: 1.25rem;
  color: transparent linear-gradient(180deg, #6A1F13 0%, #9A2411 100%) 0% 0% no-repeat padding-box !important;
  font-weight: bold !important;
  line-height: 3rem !important;
}

.quantity-button i {
  font-weight: bold !important;
}

.quantity-button {
  box-shadow: 0px 1px 2px #00000029 !important;
}

.extra-button {
  font-size: 1.05rem !important;
  height: 3.5rem !important;
  letter-spacing: 1.2px
}

.extra-label {
  font-size: 1.5vw;
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
  border-radius: 0 !important;
}

.extra-list {
  font-size: 1rem;
  font-style: italic;
}

.product-variant {
  font-size: 1rem !important;
  font-weight: 600;
  padding: 1.5rem 1rem !important;
  border-radius: 0 !important;
}

.variant-label {
  border-radius: 1rem !important;
  font-size: .9rem !important;
  font-weight: 600;
  text-align: center !important;
  letter-spacing: 1.2px
}

.variant-name {
  font-size: 1.2vw !important;
}

.product-title {
  font-size: 1.2vw !important;
  margin: 0.5rem !important;
  font-weight: 600 !important;
  text-shadow: 1px 1px 5px black !important;
}

.title-div {
  width: auto;
  border: 2px solid #6A1F13;
  display: flex;
  margin-bottom: 1rem;
  border-radius: 2rem;
  padding: 0.5rem;
}

.sale-text-shadow {
  text-shadow: 1px 1px 5px black;
}

#cartEntryRecipeSteps {
  max-height: 35vh;
  overflow-y: auto;
}

#cartProductRecipeItemSelect {
  max-height: 15vh;
  overflow-y: auto;
}

.selected-product-info-highlight {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: auto;
  max-width: 95%;
  min-width: 30%;
  padding: 3px 12px;
  border: 1px solid #6a1f13;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-top: 2px;
  gap: 8px;

  .product-name {
    font-size: 0.9rem;
    font-weight: 700;
    color: #333;
    margin-bottom: 0px;
    white-space: normal;
    text-align: center;
    word-break: break-word;
  }

  .product-price {
    font-size: 1rem;
    font-weight: 700;
    color: #6a1f13;
    white-space: nowrap;
  }

  .info-button {
    height: 1.8rem !important;
    padding: 0 1rem !important;
    font-size: 0.8rem !important;

    .vs-button-text {
      font-size: 0.8rem;
    }
  }
}

/* Kiosk Specific Sizes */
.kiosk-cart-entry {
  padding-left: 20px !important;
  padding-right: 20px !important;
  padding-top: 10px !important;
}

.kiosk-image-row {
  align-items: center;
  max-width: 90%;
  margin: 0 auto;
}

.kiosk-cart-entry .cartEntryImg {
  max-height: 220px !important;
  width: auto !important;
  object-fit: contain;
}

.kiosk-info-side-btn {
  height: 60px !important;
  width: 60px !important;
  border-radius: 50% !important;
  padding: 0 !important;
  margin-left: 15px;
}

.kiosk-info-side-btn i {
  font-size: 2rem !important;
}

.kiosk-cart-entry .quantity-label {
  font-size: 1.8rem !important;
  height: 5.5rem !important;
  padding-left: 3.5rem !important;
  padding-right: 3.5rem !important;
}

.kiosk-cart-entry .selected-quantity {
  font-size: 2.8rem !important;
  margin-left: 2.5rem !important;
  margin-right: 2.5rem !important;
  line-height: 4.5rem !important;
}

.kiosk-cart-entry .quantity-button {
  width: 5rem !important;
  height: 5rem !important;
}

.kiosk-cart-entry .quantity-button i {
  font-size: 2.2rem !important;
}

.kiosk-cart-entry .mt-10 {
  margin-top: 2rem !important;
}

.kiosk-cart-entry .product-name {
  font-size: 1.7rem !important;
  line-height: 1.2;
}

.kiosk-cart-entry .product-price {
  font-size: 2rem !important;
  color: #28c76f !important;
}

.kiosk-cart-entry .info-button {
  height: 3.2rem !important;
  padding: 0 2rem !important;
  font-size: 1.4rem !important;
}

.kiosk-cart-entry .action-button {
  height: 3.5rem !important;
  font-size: 1.2rem !important;
}

.kiosk-cart-entry .info-button .vs-button-text {
  font-size: 1.4rem !important;
}

.kiosk-cart-entry .action-button {
  font-size: 1.8rem !important;
  height: 6rem !important;
  border-radius: 1.5rem !important;
}

.kiosk-cart-entry .selected-product-info-highlight {
  width: 90% !important;
  max-width: 90% !important;
  padding: 20px 30px !important;
  border-radius: 20px !important;
  flex-direction: column !important;
  gap: 15px !important;
  margin: 40px auto 20px auto !important;
}

.kiosk-cart-entry .cartEntryImg {
  max-height: 450px !important;
}

.kiosk-cart-entry .selected-product-info-highlight {
  padding: 15px 25px !important;
  border-radius: 15px !important;
  gap: 15px !important;
  width: 100% !important;
  max-width: none !important;
  min-width: 100% !important;
}

.kiosk-footer-quantity-container {
  background: #fff;
  border-radius: 1.5rem;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  height: 6rem;
  width: 100%;
  border: 1px solid #eee;

  .selected-quantity {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
}


.cartEntryImg {
  object-fit: contain;
  max-height: 180px !important;
  width: auto;
  min-width: 8rem;
}

@media only screen and (max-width: 600px) {
  .hidden-xs {
    display: none !important;
  }
  
  .cartEntryImg {
    width: auto !important;
    max-height: 100px !important;
    min-width: 6rem;
  }

  .quantity-label {
    height: 2.5rem !important;
    font-size: 0.9rem !important;
  }

  .action-button {
    height: 3rem !important;
    font-size: 0.9rem !important;
  }

  .selected-product-info-highlight {
    width: 95% !important;
    padding: 6px 10px !important;
    gap: 8px;
    flex-wrap: wrap; /* Ensure it wraps if needed */
    justify-content: center;
    
    .product-name {
      font-size: 0.8rem !important;
      white-space: normal !important; /* Allow wrapping */
      text-align: center;
      width: 100%; /* Force new line if wrap occurs */
      margin-bottom: 2px;
    }
    
    .product-price {
      font-size: 0.8rem !important;
    }

    .info-button {
      height: 1.5rem !important;
      padding: 0 0.5rem !important;
      font-size: 0.7rem !important;
    }
  }
}


</style>
